import React from 'react';
import './NewsItem.css';

const NewsItem = ({ 
  category, 
  id, 
  title, 
  image, 
  summary, 
  timestamp, 
  source, 
  onGenerateAudio, 
  isLoading 
}) => {
  return (
    <article className={`news-item ${category}`}>
      <div className="news-image">
        <img src={image} alt={title} loading="lazy" />
        <div className="news-meta">
          <span className="news-source">{source}</span>
          <span className="news-time">{timestamp}</span>
        </div>
      </div>
      <div className="news-content">
        <h4>{title}</h4>
        <p>{summary}</p>
        <button
          className={`generate-button ${isLoading ? 'loading' : ''}`}
          onClick={() => onGenerateAudio({ id, title, summary, category })}
          disabled={isLoading}
        >
          {isLoading ? (
            <>
              <span className="loading-spinner"></span>
              Generating...
            </>
          ) : (
            <>
              <span className="play-icon">▶️</span>
              Listen Now
            </>
          )}
        </button>
      </div>
    </article>
  );
};

export default NewsItem; 